var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSearch01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 18.3334H5.49223C4.20441 18.3334 3.18009 17.7068 2.26039 16.8306C0.377641 15.0368 3.46884 13.6034 4.64782 12.9014C6.27532 11.9323 8.16042 11.5337 9.99984 11.7056",
    stroke: "#515151",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9165 5.41675C12.9165 7.48782 11.2376 9.16675 9.1665 9.16675C7.09544 9.16675 5.4165 7.48782 5.4165 5.41675C5.4165 3.34568 7.09544 1.66675 9.1665 1.66675C11.2376 1.66675 12.9165 3.34568 12.9165 5.41675Z",
    stroke: "#515151",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8889 18.773C18.1316 19.0184 18.5273 19.0205 18.7727 18.7777C19.0181 18.535 19.0202 18.1392 18.7775 17.8939L17.8889 18.773ZM16.3518 17.2193L17.8889 18.773L18.7775 17.8939L17.2404 16.3402L16.3518 17.2193ZM18.2915 14.6667C18.2915 12.6647 16.6685 11.0417 14.6665 11.0417V12.2917C15.9782 12.2917 17.0415 13.3551 17.0415 14.6667H18.2915ZM14.6665 11.0417C12.6645 11.0417 11.0415 12.6647 11.0415 14.6667H12.2915C12.2915 13.3551 13.3548 12.2917 14.6665 12.2917V11.0417ZM11.0415 14.6667C11.0415 16.6688 12.6645 18.2917 14.6665 18.2917V17.0417C13.3548 17.0417 12.2915 15.9784 12.2915 14.6667H11.0415ZM14.6665 18.2917C16.6685 18.2917 18.2915 16.6688 18.2915 14.6667H17.0415C17.0415 15.9784 15.9782 17.0417 14.6665 17.0417V18.2917Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSearch01);
export default __webpack_public_path__ + "static/media/user-search-01.f7897915c904c53cc76c49ced9419915.svg";
export { ForwardRef as ReactComponent };